


































import { Component, Vue } from 'vue-property-decorator'

/**
 * 查询支付状态
 */
@Component
export default class PayType extends Vue {
  private success: any = ''
  public mounted() {
    this.success = this.$route.query.success
    console.log(this.$route.query)
  }

  protected orderPage() {
    this.$router.push({ name: 'order' })
  }
  protected recharge() {
    window.location.href = '/user/#/finance-recharge'
  }

  protected backEnter() {
    window.location.href = '/user/#/'
  }

}
